import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const PaymentSuccessPage: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => navigate('/'), 5000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)',
    }}>
      <div style={{
        background: '#fff',
        borderRadius: 20,
        padding: '48px 40px',
        maxWidth: 480,
        width: '90%',
        textAlign: 'center',
        boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
      }}>
        <div style={{ fontSize: 72, marginBottom: 16 }}>✅</div>
        <h1 style={{ color: '#2e7d32', margin: '0 0 12px', fontSize: 28, fontWeight: 700 }}>
          Payment Successful!
        </h1>
        <p style={{ color: '#555', fontSize: 16, margin: '0 0 24px' }}>
          Your subscription has been activated. Thank you for your payment!
        </p>
        <div style={{
          background: '#e8f5e9', borderRadius: 10, padding: '12px 16px',
          color: '#388e3c', fontSize: 14, marginBottom: 28,
        }}>
          You will be redirected to the dashboard in 5 seconds…
        </div>
        <button
          onClick={() => navigate('/')}
          style={{
            background: '#4caf50', color: '#fff', border: 'none',
            borderRadius: 10, padding: '14px 32px',
            fontWeight: 700, fontSize: 16, cursor: 'pointer',
            width: '100%',
          }}
        >
          Go to Dashboard
        </button>
      </div>
    </div>
  );
};

export default PaymentSuccessPage;
